interface IconProps {
  color?: string;
  size?: string | number;
}

const StarIcon = ({ color = "currentColor", size = 24 }: IconProps) => {
  return (
    <svg height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_11_557)">
        <path d="M12 18.245L7.019 21.245C6.81568 21.3807 6.57267 21.4441 6.329 21.425C6.09987 21.4092 5.88061 21.3256 5.699 21.185C5.51953 21.0456 5.37561 20.8657 5.279 20.66C5.17788 20.4387 5.15668 20.1892 5.219 19.954L6.539 14.283L2.127 10.473C1.93939 10.3132 1.80825 10.0972 1.753 9.85703C1.702 9.63251 1.71729 9.39802 1.797 9.18203C1.86886 8.97421 1.9928 8.78829 2.157 8.64203C2.34606 8.48975 2.57542 8.39592 2.817 8.37203L8.638 7.86203L10.885 2.52603C10.9744 2.29828 11.1388 2.10781 11.351 1.98603C11.5456 1.86832 11.7686 1.80609 11.996 1.80609C12.2234 1.80609 12.4464 1.86832 12.641 1.98603C12.8527 2.10811 13.0167 2.29852 13.106 2.52603L15.357 7.86703L21.178 8.37703C21.4196 8.40087 21.649 8.4947 21.838 8.64703C22.0022 8.79329 22.1261 8.97921 22.198 9.18703C22.2778 9.40296 22.2937 9.63727 22.244 9.86203C22.1877 10.1023 22.056 10.3182 21.868 10.478L17.457 14.289L18.777 19.96C18.8393 20.1952 18.8181 20.4447 18.717 20.666C18.6204 20.8717 18.4765 21.0516 18.297 21.191C18.1154 21.3316 17.8961 21.4152 17.667 21.431C17.4233 21.4501 17.1803 21.3867 16.977 21.251L12 18.245Z" />
      </g>
      <defs>
        <clipPath id="clip0_11_557">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default StarIcon;
